import { render, staticRenderFns } from "./ProfileBonuses.vue?vue&type=template&id=15508df4&scoped=true&"
import script from "./ProfileBonuses.js?vue&type=script&lang=js&"
export * from "./ProfileBonuses.js?vue&type=script&lang=js&"
import style0 from "./ProfileBonuses.scss?vue&type=style&index=0&id=15508df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15508df4",
  null
  
)

export default component.exports